export default __webpack_public_path__ + "static/media/ContactImportedIcon.de229f72.svg";